<template>
  <div>
    <template v-if="$route.name === 'Properties'">
      <v-row>
        <v-col cols="12" md="6">
          <PropertiesList :darkMode="$props.darkMode" :properties="properties"></PropertiesList>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <transition name="fade-transition" mode="out-in">
        <router-view :darkMode="$props.darkMode" :id="$props.id" :property="property"></router-view>
      </transition>
    </template>

  </div>
</template>

<script>
import PropertiesList from "../components/Properties/PropertiesList";
import { mapGetters } from "vuex";

export default {
  name: 'Properties',
  components:{
    PropertiesList
  },
  computed:{
    ...mapGetters([
      'property',
      'properties',
    ]),
  },
  data: () => ({}),
  props: {
    darkMode:{
      type:Boolean,
      default: false
    },
  },
  created(){},

}
</script>

<style lang="scss" scoped>

</style>
